module.exports = __webpack_public_path__ + "static/media/mubiao1.8478f320.png";